import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthenticationService } from '../authentication/authentication.service';
import { NotificationsService } from '../services/notifications.service';
import { ErrorMessage, NotificationType } from '../constants/notifications';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(
        private authenticationService: AuthenticationService,
        private notificationsService: NotificationsService
    ) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
            catchError((err: any) => {
                switch (err.status) {
                    case 0:
                        break;
                    case 401:
                        this.authenticationService.logout(true).catch(() => {});
                        break;
                    case 403:
                        this.notificationsService.showNotification(
                            NotificationType.Error,
                            ErrorMessage.forbidden
                        );
                        break;
                    default:
                        this.notificationsService.showNotification(
                            NotificationType.Error,
                            ErrorMessage.default
                        );
                }

                const error: string = err.error.message || err.statusText;
                return throwError(() => new Error(error));
            })
        );
    }
}
